import { Input, ViewChild, ElementRef, Directive } from '@angular/core';
import { AppContext } from '../control/context';
import { FeaturesImpl } from '../model/features-impl';
import { DateTime } from 'luxon'

@Directive()
export class PrintForm {
  @Input() model: any;

  @ViewChild('resizer', { static: true }) private resizer: ElementRef<HTMLSpanElement>;

  private spliced = new Set<HTMLSpanElement>();

  constructor(protected appContext: AppContext) {}

  slice(elementU: HTMLSpanElement, elementD: HTMLSpanElement, text: string): string {
    if (text && !this.spliced.has(elementU) && !this.spliced.has(elementD)) {
      let bestPos = -1;
      for (let pos = 0; pos <= text.length; ++pos) {
        if (pos === text.length || text[pos] === ' ') {
          this.resizer.nativeElement.textContent = text.substr(0, pos);
          if (this.resizer.nativeElement.offsetWidth > elementU.clientWidth) {
            break;
          }
          bestPos = pos;
        }
      }
      this.resizer.nativeElement.textContent = '';
      elementU.textContent = text.substr(0, bestPos);
      elementD.textContent = text.substr(bestPos + 1);
      this.spliced.add(elementU);
      this.spliced.add(elementD);
    }
    return '';
  }

  joinImpl(delimiter: string, ...items: any[]): string {
    let result = '';
    for (const item of items) {
      let val;
      if (item instanceof Array) {
        val = this.joinImpl(delimiter, ...item);
      } else if (item instanceof Object) {
        if (item.delimiter) {
          delimiter = item.delimiter;
        }
        if (item.path) {
          val = FeaturesImpl.makeString(this.model, item.path, this.appContext);
          if (val && item.prefix) {
            val = item.prefix + val;
          }
        }
      } else if (typeof item === 'string') {
        val = FeaturesImpl.makeString(this.model, item, this.appContext);
      }
      if (val) {
        if (result) {
          result += delimiter;
        }
        result += val;
      }
    }
    return result;
  }

  join(...items: any[]): string {
    return this.joinImpl(' ', ...items);
  }

  join2(...items: any[]): string {
    return this.joinImpl('', ...items);
  }

  datePart(part: 'D' | 'M' | 'Y', path: string): string {
    return FeaturesImpl.makeDatePartString(this.model, part, path, this.appContext);
  }

  datePartToday(part: 'D' | 'M' | 'Y'): string {
    const today = new Date();
    switch (part) {
      case 'D':
        return ('0' + today.getDate()).slice(-2);
      case 'M':
        return ('0' + (today.getMonth() + 1)).slice(-2);
      case 'Y':
        return today.getFullYear().toString();
      default:
        throw new Error('Invalid date part');
    }
  }

  dateMonthAsWord(): string {
    const today = DateTime.now();
    return today.toFormat("MMMM", { locale: 'ru' });
  }
}
